module.exports = __webpack_public_path__ + "static/media/aictia.8f23b10e.png";